var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('sui-container',[_c('div',{attrs:{"id":"logo"},on:{"click":_vm.goHome}}),_c('div',{attrs:{"id":"banner"}}),_c('router-view'),_c('Footer')],1),_c('CookieLaw')],1)}
var staticRenderFns = []

export { render, staticRenderFns }